var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtaHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4551 9.125C19.5146 9.40995 20.4807 9.9683 21.2565 10.7441C22.0323 11.5199 22.5906 12.486 22.8756 13.5455",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8066 11.5405C18.4424 11.7115 19.022 12.0465 19.4875 12.512C19.953 12.9775 20.288 13.5571 20.459 14.1928",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2247 15.7513C13.873 17.0767 14.9474 18.1462 16.2758 18.7885C16.3729 18.8346 16.4804 18.8545 16.5877 18.8464C16.6949 18.8383 16.7982 18.8024 16.8874 18.7422L18.8433 17.438C18.9298 17.3803 19.0293 17.3451 19.1328 17.3356C19.2364 17.3261 19.3407 17.3426 19.4362 17.3835L23.0954 18.9517C23.2197 19.0045 23.3234 19.0963 23.3911 19.2132C23.4587 19.3301 23.4865 19.4658 23.4702 19.5999C23.3546 20.5049 22.913 21.3367 22.2282 21.9396C21.5434 22.5425 20.6624 22.8751 19.75 22.8751C16.9321 22.8751 14.2296 21.7557 12.237 19.7631C10.2444 17.7706 9.125 15.0681 9.125 12.2501C9.12505 11.3378 9.45765 10.4567 10.0605 9.77192C10.6634 9.08712 11.4952 8.64556 12.4002 8.5299C12.5343 8.51368 12.67 8.54146 12.7869 8.60908C12.9038 8.67669 12.9956 8.78046 13.0484 8.90476L14.618 12.5671C14.6586 12.6618 14.6751 12.7651 14.6661 12.8678C14.6572 12.9705 14.6229 13.0693 14.5665 13.1556L13.2668 15.1415C13.2076 15.2308 13.1726 15.334 13.1653 15.4409C13.1579 15.5477 13.1784 15.6547 13.2247 15.7513V15.7513Z",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaHomeIcon);
export default __webpack_public_path__ + "static/media/cta-home-icon.de7d888cc7625b644a7e4127a9848fc6.svg";
export { ForwardRef as ReactComponent };